export interface LocalizationStrings {
  loading_story_list_error: string;
  loading_generated_story_list_error: string;
  loading_story: string;
  loading_story_error: string;
  story_not_found_error: string;
  story_alignment_error: string;
  story_back_to_library: string;
  story_login_required: string;
  story_load_retry: string;
  loading_explain: string;
  loading_explain_error: string;
  save_word_preparing: string;
  listen_button: string;
  listen_stop: string;
  listen_loading: string;
  listen_error: string;
  save_word_button: string;
  explanation_phrase_label: string;
  saving_word: string;
  word_saved: string;
  save_word_error: string;
  save_word_limit_error: string;
  remove_word_button: string;
  remove_word_error: string;
  my_dictionary_nav: string;
  my_dictionary_header: string;
  my_dictionary_loading: string;
  my_dictionary_error: string;
  my_dictionary_empty: string;
  my_dictionary_meaning_pending: string;
  my_dictionary_examples_heading: string;
  my_dictionary_prev_page: string;
  my_dictionary_next_page: string;
  my_dictionary_page_label: string;
  my_dictionary_delete: string;
  my_dictionary_delete_confirm: string;
  my_dictionary_delete_cancel: string;
  my_dictionary_deleting: string;
  my_dictionary_delete_error: string;
  my_dictionary_login_prompt: string;
  settings_title: string;
  close_button_caption: string;
  cancel_button: string;
  generate_overlay_message: string;
  // Template; {level} is replaced with the CEFR code (A1/B1/C1).
  generate_overlay_headline: string;
  scan_overlay_message: string;
  upload_overlay_message: string;
  my_stories_header: string;
  scan_no_target_text_error: string;
  scan_error_disallowed: string;
  scan_error: string;
  upload_title_pre: string;
  upload_title_post: string;
  upload_textarea_placeholder: string;
  upload_textarea_heading: string;
  upload_submit: string;
  upload_in_progress: string;
  upload_login_prompt: string;
  upload_too_long: string;
  upload_error_disallowed: string;
  upload_error_no_target_text: string;
  upload_error_generic: string;
  reader_menu_label: string;
  reader_menu_words_section: string;
  translation_menu_title: string;
  translation_unavailable: string;
  translation_mode_hidden: string;
  translation_mode_by_paragraph: string;
  translation_mode_by_sentence: string;
  color_noun_genders_checkbox: string;
  color_noun_genders_masculine: string;
  color_noun_genders_feminine: string;
  color_noun_genders_neuter: string;
  login_button: string;
  signup_button: string;
  logout_button: string;
  settings_theme: string;
  settings_theme_dark: string;
  settings_theme_light: string;
  settings_theme_system: string;
  generate_title_pre: string;
  generate_title_post: string;
  generate_level_heading: string;
  generate_mood_heading: string;
  generate_topic_heading: string;
  generate_topic_optional: string;
  generate_instructions_heading: string;
  generate_instructions_placeholder: string;
  generate_instructions_help: string;
  generate_instructions_too_long: string;
  generate_login_prompt: string;
  generate_button: string;
  generate_level_required: string;
  generate_error: string;
  generate_error_disallowed: string;
  generate_error_off_topic: string;
  create_error_daily_limit_reached: string;
  create_error_request_in_progress: string;
  create_error_server_busy: string;
  create_error_daily_limit_reached_unverified: string;
  email_verification_notice: string;
  email_verification_send: string;
  email_verification_check: string;
  email_verification_sent: string;
  email_verification_still_unverified: string;
  email_verification_error: string;
  login_verification_sent_title: string;
  login_verification_sent_message: string;
  login_verification_sent_continue: string;
  generate_in_progress: string;
  delete_story_confirm_title: string;
  delete_story_confirm_message: string;
  delete_story_confirm_button: string;
  delete_story_button_label: string;
  delete_story_deleting: string;
  delete_story_error: string;
  favorite_story_button_label: string;
  unfavorite_story_button_label: string;
  favorite_story_error: string;
  mark_story_read_button_label: string;
  mark_story_unread_button_label: string;
  read_story_error: string;
  practice_nav: string;
  practice_header: string;
  practice_all_words_link: string;
  practice_autoplay: string;
  practice_answer_error: string;
  practice_loading: string;
  practice_error: string;
  practice_check_again: string;
  practice_keyboard_help: string;
  practice_new_word: string;
  practice_tricky_word: string;
  practice_prompt_recognize_word: string;
  practice_prompt_recognize_sentence: string;
  practice_prompt_produce_word: string;
  practice_prompt_produce_sentence: string;
  practice_type_placeholder: string;
  practice_hint: string;
  practice_reveal: string;
  practice_hint_grade_note: string;
  practice_grade_forgot: string;
  practice_grade_hard: string;
  practice_grade_medium: string;
  practice_grade_easy: string;
  practice_typed_correct: string;
  practice_typed_wrong: string;
  practice_status_due: string;
  practice_status_new: string;
  practice_status_level: string;
  practice_next_due_minutes: string;
  practice_next_due_hours: string;
  practice_next_due_days: string;
  practice_done_caught_up: string;
  practice_done_goal_title: string;
  practice_done_goal_text: string;
  practice_done_cap_text: string;
  practice_done_struggling_text: string;
  practice_done_consolidating_text: string;
  practice_learn_more: string;
  practice_home_due: string;
  practice_home_start: string;
  placement_title: string;
  placement_text: string;
  placement_start: string;
  placement_skip: string;
  placement_loading: string;
  placement_question: string;
  placement_known: string;
  placement_unknown: string;
  placement_keyboard_help: string;
  placement_done_title: string;
  placement_done_text: string;
  placement_continue: string;
  gender_round_title: string;
  gender_round_result: string;
  strength_recognize: string;
  strength_produce: string;
  strength_unpracticed: string;
  strength_weak: string;
  strength_learning: string;
  strength_strong: string;
  my_dictionary_filter_saved: string;
  my_dictionary_filter_all: string;
  my_dictionary_sort_recent: string;
  my_dictionary_sort_weakest: string;
  my_dictionary_sort_strongest: string;
  my_dictionary_tricky: string;
  my_dictionary_all_empty: string;
  account_menu_label: string;
  login_title_signin: string;
  login_title_signup: string;
  login_subtitle_signin: string;
  login_subtitle_signup: string;
  login_email_label: string;
  login_password_label: string;
  login_password_hint_signup: string;
  login_submit_signin: string;
  login_submit_signup: string;
  login_submit_signin_pending: string;
  login_submit_signup_pending: string;
  login_or: string;
  login_google_button: string;
  login_toggle_to_signup_question: string;
  login_toggle_to_signin_question: string;
  login_toggle_to_signup: string;
  login_toggle_to_signin: string;
  login_error_invalid_credentials: string;
  login_error_email_in_use: string;
  login_error_weak_password: string;
  login_error_invalid_email: string;
  login_error_too_many_requests: string;
  login_error_generic: string;
  home_hero_title_pre: string;
  home_hero_title_highlight: string;
  home_hero_subtitle: string;
  home_how_read_title: string;
  home_how_read_description: string;
  home_how_tap_title: string;
  home_how_tap_description: string;
  home_how_save_title: string;
  home_how_save_description: string;
  home_create_heading: string;
  home_create_subtitle: string;
  home_create_generate_title: string;
  home_create_generate_description: string;
  home_create_scan_title: string;
  home_create_scan_description: string;
  home_create_upload_title: string;
  home_create_upload_description: string;
  home_cta_title: string;
  home_cta_subtitle: string;
  home_cta_button: string;
  nav_stories: string;
  nav_words: string;
  reader_back: string;
  text_size_title: string;
  text_size_small: string;
  text_size_medium: string;
  text_size_large: string;
  read_along_listen: string;
  read_along_pause: string;
  read_along_resume: string;
  read_along_speed: string;
  generate_page_title: string;
  upload_page_title: string;
  language_i_speak: string;
  language_i_learn: string;
  settings_languages: string;
  settings_appearance: string;
  greeting_morning: string;
  greeting_afternoon: string;
  greeting_evening: string;
  greeting_night: string;
  home_subtitle: string;
  continue_reading: string;
  // Template; {percent} is a whole number.
  percent_read: string;
  story_of_the_day: string;
  featured_story_read: string;
  featured_story_done: string;
  practice_card_placement: string;
  practice_card_new: string;
  practice_card_done: string;
  create_heading: string;
  create_new_story: string;
  create_scan: string;
  create_paste: string;
  library_header: string;
  library_subtitle: string;
  library_surprise: string;
  library_search_label: string;
  library_search_placeholder: string;
  library_search_clear: string;
  library_all_levels: string;
  library_no_results: string;
  // Template; {count} is the number of stories, always more than a few.
  library_show_all: string;
  home_start_reading: string;
  home_browse_library: string;
  home_preview_label: string;
  // Template; {count} is the estimated reading time in minutes.
  story_minutes: string;
  coach_tap_word: string;
  coach_got_it: string;
  resume_toast: string;
  resume_start_over: string;
  signup_to_save: string;
  story_end_title: string;
  story_end_congrats: string;
  story_end_read_done: string;
  story_end_signup_text: string;
  story_end_up_next: string;
  story_rating_question: string;
  story_rating_star_label: string;
  story_rating_thanks: string;
  story_rating_error: string;
  story_end_practice: string;
  story_end_practice_story: string;
  practice_story_header: string;
  practice_story_done_title: string;
  practice_story_done_text: string;
  practice_story_back: string;
  practice_story_continue: string;
  practice_done_reviews: string;
  practice_done_new_words: string;
  practice_read_story: string;
  my_dictionary_empty_cta: string;
  generate_subtitle: string;
  levels: Record<string, string>;
  moods: Record<string, string>;
  topics: Record<string, string>;
}

const strings = new Map<string, LocalizationStrings>([
  [
    "en",
    {
      loading_story_list_error: "Error loading story list",
      loading_generated_story_list_error: "Error loading generated story list",
      loading_story: "Loading story...",
      loading_story_error: "Error loading story",
      story_not_found_error: "Story not found :(",
      story_alignment_error:
        "This part of the story can't be shown: its translation doesn't line up with the original.",
      story_back_to_library: "Back to the library",
      story_login_required: "Log in to read this story.",
      story_load_retry: "Try again",
      loading_explain: "Loading explanation...",
      loading_explain_error: "Error loading explanation",
      save_word_preparing: "Preparing...",
      listen_button: "Listen",
      listen_stop: "Stop",
      listen_loading: "Loading...",
      listen_error: "Couldn't play the audio — try again",
      save_word_button: "Save word",
      explanation_phrase_label: "Part of",
      saving_word: "Saving...",
      word_saved: "Saved",
      save_word_error: "Couldn't save — try again",
      save_word_limit_error:
        "Dictionary full (1000 words) — remove some to save more",
      remove_word_button: "Remove from dictionary",
      remove_word_error: "Couldn't remove — try again",
      my_dictionary_nav: "My dictionary",
      my_dictionary_header: "My dictionary",
      my_dictionary_loading: "Loading your dictionary...",
      my_dictionary_error: "Couldn't load your dictionary — try again",
      my_dictionary_empty:
        "No saved words yet. Tap a word while reading and save it to your dictionary.",
      my_dictionary_meaning_pending: "Translation pending...",
      my_dictionary_examples_heading: "Examples",
      my_dictionary_prev_page: "Previous",
      my_dictionary_next_page: "Next",
      my_dictionary_page_label: "Page",
      my_dictionary_delete: "Delete",
      my_dictionary_delete_confirm: "Delete?",
      my_dictionary_delete_cancel: "Cancel",
      my_dictionary_deleting: "Deleting...",
      my_dictionary_delete_error: "Couldn't delete — try again",
      my_dictionary_login_prompt: "Log in to see your saved words",
      settings_title: "Settings",
      close_button_caption: "Close",
      cancel_button: "Cancel",
      generate_overlay_message: "Crafting your story",
      generate_overlay_headline: "Your {level} story is on its way",
      scan_overlay_message: "Reading your page",
      upload_overlay_message: "Polishing your text",
      my_stories_header: "My stories",
      scan_no_target_text_error:
        "No text in your learned language was found in the image",
      scan_error_disallowed:
        "The text in this image isn't allowed as learning material. Please try a different page.",
      scan_error: "Couldn't process the image — try again",
      upload_title_pre: "Upload your own",
      upload_title_post: "text.",
      upload_textarea_heading: "PASTE A PASSAGE",
      upload_textarea_placeholder:
        "Paste a passage in the language you're learning — a letter, an article, a few pages of a book...",
      upload_submit: "Upload",
      upload_in_progress: "Processing...",
      upload_login_prompt: "Log in to upload your own text",
      upload_too_long: "Text is too long",
      upload_error_disallowed:
        "This text isn't allowed as learning material. Please try a different passage.",
      upload_error_no_target_text:
        "No text in your learned language was found in the passage",
      upload_error_generic: "Couldn't process the text — try again",
      reader_menu_label: "Reading options",
      reader_menu_words_section: "Words",
      translation_menu_title: "Translation",
      translation_unavailable: "No translation available for this story.",
      translation_mode_hidden: "Hidden",
      translation_mode_by_paragraph: "By paragraph",
      translation_mode_by_sentence: "By sentence",
      color_noun_genders_checkbox: "Color nouns by gender",
      color_noun_genders_masculine: "masculine",
      color_noun_genders_feminine: "feminine",
      color_noun_genders_neuter: "neuter",
      login_button: "Log in",
      signup_button: "Sign up",
      logout_button: "Log out",
      settings_theme: "Theme",
      settings_theme_dark: "Dark",
      settings_theme_light: "Light",
      settings_theme_system: "System",
      generate_title_pre: "Create a new",
      generate_title_post: "story.",
      generate_level_heading: "YOUR LEVEL",
      generate_mood_heading: "Mood",
      generate_topic_heading: "Topic",
      generate_topic_optional: "Optional",
      generate_instructions_heading: "Custom instructions",
      generate_instructions_placeholder:
        "e.g. focus on the past perfect tense, or a story about a dog that ran away...",
      generate_instructions_help:
        "Steer the story your way: a grammar structure to practice, vocabulary to include, or a plot idea.",
      generate_instructions_too_long: "Instructions are too long",
      generate_login_prompt: "Log in to generate a new story",
      generate_button: "Create",
      generate_level_required: "Choose a level",
      generate_error: "Error — try again",
      generate_error_disallowed:
        "These instructions aren't allowed for story generation. Please rephrase them.",
      generate_error_off_topic:
        "This field only shapes your story — try a grammar focus, vocabulary, or a plot idea instead.",
      create_error_daily_limit_reached:
        "You've reached the 24-hour limit — try again later",
      create_error_request_in_progress:
        "Another story is still being created — wait for it to finish",
      create_error_server_busy: "We're busy right now — try again in a minute",
      create_error_daily_limit_reached_unverified:
        "You've reached the 24-hour limit — verify your email to raise it, or try again later",
      email_verification_notice:
        "Verify your email address {email} to raise your daily limits.",
      email_verification_send: "Send verification email",
      email_verification_check: "I've verified it",
      email_verification_sent: "Sent — check your inbox and spam folder",
      email_verification_still_unverified:
        "Not verified yet — open the link in the email first",
      email_verification_error: "Something went wrong — please try again",
      login_verification_sent_title: "Check your inbox",
      login_verification_sent_message:
        "We sent a link to {email}. Open it to verify your email and raise your daily limits — you can start right away.",
      login_verification_sent_continue: "Continue",
      generate_in_progress: "Generating...",
      delete_story_confirm_title: "Delete this story?",
      delete_story_confirm_message:
        "The story and all its data will be permanently removed.",
      delete_story_confirm_button: "Delete",
      delete_story_button_label: "Delete story",
      delete_story_deleting: "Deleting...",
      delete_story_error: "Couldn't delete the story — try again",
      favorite_story_button_label: "Add to favorites",
      unfavorite_story_button_label: "Remove from favorites",
      favorite_story_error: "Couldn't update favorites — try again",
      mark_story_read_button_label: "Mark as read",
      mark_story_unread_button_label: "Mark as unread",
      read_story_error: "Couldn't update the read mark — try again",
      practice_nav: "Practice",
      practice_header: "Practice",
      practice_all_words_link: "All my words",
      practice_autoplay: "Play audio automatically",
      practice_answer_error: "Couldn't save some answers. Check your connection.",
      practice_loading: "Loading…",
      practice_error: "Something went wrong. Please try again.",
      practice_check_again: "Check again",
      practice_keyboard_help: "Keys: Space shows the answer, H gives a hint, 1–4 grade",
      practice_new_word: "New word",
      practice_tricky_word: "Tricky word",
      practice_prompt_recognize_word: "What does it mean?",
      practice_prompt_recognize_sentence: "What does the highlighted word mean?",
      practice_prompt_produce_word: "How do you say it?",
      practice_prompt_produce_sentence: "Fill the gap",
      practice_type_placeholder: "Type your answer (optional)",
      practice_hint: "Hint",
      practice_reveal: "Show answer",
      practice_hint_grade_note: "You used a hint, so this counts as hard at best.",
      practice_grade_forgot: "Forgot",
      practice_grade_hard: "Hard",
      practice_grade_medium: "Medium",
      practice_grade_easy: "Easy",
      practice_typed_correct: "You got it right",
      practice_typed_wrong: "You wrote: {typed}",
      practice_status_due: "{count} to review",
      practice_status_new: "{done}/{goal} new today",
      practice_status_level: "Level {level}",
      practice_next_due_minutes: "Next review in {count} min",
      practice_next_due_hours: "Next review in {count} h",
      practice_next_due_days: "Next review in {count} days",
      practice_done_caught_up: "All caught up!",
      practice_done_goal_title: "Daily goal reached!",
      practice_done_goal_text: "You learned {count} new words today.",
      practice_done_cap_text: "You learned {count} new words today. That's plenty for one day: new words resume tomorrow.",
      practice_done_struggling_text: "Today's new words need some time to sink in. Take a break and come back later.",
      practice_done_consolidating_text: "Your newest words are still settling in. More in a few minutes.",
      practice_learn_more: "Learn {count} more",
      practice_home_due: "{count} words to review",
      practice_home_start: "Practice words",
      placement_title: "Find your level",
      placement_text: "A one-minute check: tap whether you know each word. Some words are made up, so be honest! Your new words will then match your level.",
      placement_start: "Start",
      placement_skip: "Skip",
      placement_loading: "Preparing the words…",
      placement_question: "Do you know this word?",
      placement_known: "I know it",
      placement_unknown: "Don't know",
      placement_keyboard_help: "Keys: → I know it, ← don't know",
      placement_done_title: "All set!",
      placement_done_text: "Your new words will come from level {level}. It keeps adjusting as you practice.",
      placement_continue: "Continue",
      gender_round_title: "Gender round",
      gender_round_result: "{correct} of {total} right",
      strength_recognize: "Recognition",
      strength_produce: "Recall",
      strength_unpracticed: "not practiced yet",
      strength_weak: "weak",
      strength_learning: "getting there",
      strength_strong: "strong",
      my_dictionary_filter_saved: "Saved",
      my_dictionary_filter_all: "All words",
      my_dictionary_sort_recent: "Recently added",
      my_dictionary_sort_weakest: "Weakest first",
      my_dictionary_sort_strongest: "Strongest first",
      my_dictionary_tricky: "Tricky",
      my_dictionary_all_empty: "No words yet. Words you look up in stories and practice show up here.",
      account_menu_label: "Account menu",
      login_title_signin: "Welcome Back",
      login_title_signup: "Create Account",
      login_subtitle_signin: "Log in to continue your experience",
      login_subtitle_signup: "Sign up to start your journey",
      login_email_label: "Email",
      login_password_label: "Password",
      login_password_hint_signup: "At least 6 characters",
      login_submit_signin: "Log in",
      login_submit_signup: "Sign up",
      login_submit_signin_pending: "Logging in...",
      login_submit_signup_pending: "Signing up...",
      login_or: "OR",
      login_google_button: "Continue with Google",
      login_toggle_to_signup_question: "Don't have an account yet? ",
      login_toggle_to_signin_question: "Already have an account? ",
      login_toggle_to_signup: "Sign up",
      login_toggle_to_signin: "Log in",
      login_error_invalid_credentials: "Wrong email or password",
      login_error_email_in_use: "An account with this email already exists",
      login_error_weak_password:
        "Password is too weak — use at least 6 characters",
      login_error_invalid_email: "This email address doesn't look right",
      login_error_too_many_requests:
        "Too many attempts — please wait a moment and try again",
      login_error_generic: "Couldn't log in — please try again",
      home_hero_title_pre: "Learn a language by",
      home_hero_title_highlight: "reading stories.",
      home_hero_subtitle:
        "Short parallel stories at your level, with translations and instant word explanations. Start reading right away — no account needed.",
      home_how_read_title: "Read at your level",
      home_how_read_description:
        "Every story is graded by CEFR level, so you can pick one that fits.",
      home_how_tap_title: "Tap any word",
      home_how_tap_description:
        "Get an instant explanation of any word, right in context.",
      home_how_save_title: "Grow your dictionary",
      home_how_save_description:
        "Save the words you want to remember and review them anytime.",
      home_create_heading: "Make it personal",
      home_create_subtitle:
        "With a free account you can turn anything into a story:",
      home_create_generate_title: "Generate a story",
      home_create_generate_description:
        "Pick a level, mood and topic — get a brand-new story written just for you.",
      home_create_scan_title: "Scan a book page",
      home_create_scan_description:
        "Photograph a page and read it with tap-to-explain.",
      home_create_upload_title: "Upload any text",
      home_create_upload_description:
        "Paste a letter, article or book excerpt and turn it into a parallel reader.",
      home_cta_title: "Ready to dive in?",
      home_cta_subtitle:
        "Create a free account to generate stories, scan pages and save words.",
      home_cta_button: "Sign up — it's free",
      nav_stories: "Stories",
      nav_words: "Words",
      reader_back: "Back",
      text_size_title: "Text size",
      text_size_small: "Small",
      text_size_medium: "Medium",
      text_size_large: "Large",
      read_along_listen: "Listen to the story",
      read_along_pause: "Pause",
      read_along_resume: "Resume",
      read_along_speed: "Listening speed",
      generate_page_title: "New story",
      upload_page_title: "Your text",
      language_i_speak: "I speak",
      language_i_learn: "I'm learning",
      settings_languages: "Languages",
      settings_appearance: "Appearance",
      greeting_morning: "Good morning",
      greeting_afternoon: "Good afternoon",
      greeting_evening: "Good evening",
      greeting_night: "Hello, night owl",
      home_subtitle: "What will you read today?",
      continue_reading: "Continue reading",
      percent_read: "{percent}% read",
      story_of_the_day: "Today's story",
      featured_story_read: "Start reading",
      featured_story_done: "Read! A new story tomorrow",
      practice_card_placement: "Find your level in one minute",
      practice_card_new: "New words waiting: {count}",
      practice_card_done: "All done for now",
      create_heading: "Create your own",
      create_new_story: "New story",
      create_scan: "Scan a page",
      create_paste: "Paste text",
      library_header: "Library",
      library_subtitle: "Hand-picked stories to read and explore",
      library_surprise: "Surprise me",
      library_search_label: "Search stories",
      library_search_placeholder: "Search by title",
      library_search_clear: "Clear search",
      library_all_levels: "All levels",
      library_no_results: "No stories match your search.",
      library_show_all: "Show all {count} stories",
      home_start_reading: "Start reading",
      home_browse_library: "Browse the library",
      home_preview_label: "Tap a word, get it explained",
      story_minutes: "{count} min read",
      coach_tap_word: "Tap any word to see what it means",
      coach_got_it: "Got it",
      resume_toast: "Picked up where you left off",
      resume_start_over: "Start over",
      signup_to_save: "Sign up to save words",
      story_end_title: "The End",
      story_end_congrats: "You read the whole story — well done!",
      story_end_read_done: "Marked as read",
      story_end_signup_text: "Create a free account to save words, practice them and keep track of your stories.",
      story_end_up_next: "Up next",
      story_rating_question: "How did you like this story?",
      story_rating_star_label: "{rating} of {max} stars",
      story_rating_thanks: "Thanks for rating!",
      story_rating_error: "Couldn't save your rating — try again",
      story_end_practice: "Practice your words",
      story_end_practice_story: "Practice words from this story ({count})",
      practice_story_header: "Words from the story",
      practice_story_done_title: "Story words practiced!",
      practice_story_done_text: "That's all from this story for now. Its words will come back in your regular practice.",
      practice_story_back: "Back to the story",
      practice_story_continue: "Continue regular practice",
      practice_done_reviews: "Reviewed today: {count}",
      practice_done_new_words: "New words today: {count}",
      practice_read_story: "Read a story",
      my_dictionary_empty_cta: "Find a story",
      generate_subtitle: "Pick a level — and, if you like, a mood and a topic. We'll write a story just for you.",
      levels: {
        A1: "Beginner",
        B1: "Intermediate",
        C1: "Advanced",
      },
      moods: {
        romantic: "Romantic",
        dark: "Dark",
        funny: "Funny",
        silly: "Silly",
        scary: "Scary",
        hopeful: "Hopeful",
        mysterious: "Mysterious",
        exciting: "Exciting",
        charming: "Charming",
        thoughtful: "Thoughtful",
        inspiring: "Inspiring",
        witty: "Witty",
      },
      topics: {
        office: "Office",
        family: "Family",
        travel: "Travel",
        sports: "Sports",
        technology: "Technology",
        cooking: "Cooking",
        fashion: "Fashion",
        music: "Music",
        science: "Science",
        history: "History",
        nature: "Nature",
        movies: "Movies",
      },
    },
  ],
  [
    "de",
    {
      loading_story_list_error: "Fehler beim Laden der Geschichtenliste",
      loading_generated_story_list_error:
        "Fehler beim Laden der Liste der generierten Storys",
      loading_story: "Lade Geschichte...",
      loading_story_error: "Fehler beim Laden der Geschichte",
      story_not_found_error: "Geschichte nicht gefunden :(",
      story_alignment_error:
        "Dieser Teil der Geschichte kann nicht angezeigt werden: Die Übersetzung passt nicht zum Original.",
      story_back_to_library: "Zurück zur Bibliothek",
      story_login_required: "Melde dich an, um diese Geschichte zu lesen.",
      story_load_retry: "Erneut versuchen",
      loading_explain: "Lade Erklärung...",
      loading_explain_error: "Fehler beim Laden der Erklärung",
      save_word_preparing: "Wird vorbereitet...",
      listen_button: "Anhören",
      listen_stop: "Stopp",
      listen_loading: "Wird geladen...",
      listen_error: "Audio konnte nicht abgespielt werden — bitte erneut versuchen",
      save_word_button: "Wort speichern",
      explanation_phrase_label: "Teil von",
      saving_word: "Wird gespeichert...",
      word_saved: "Gespeichert",
      save_word_error: "Speichern fehlgeschlagen — bitte erneut versuchen",
      save_word_limit_error:
        "Wörterbuch voll (1000 Wörter) — bitte einige entfernen",
      remove_word_button: "Aus dem Wörterbuch entfernen",
      remove_word_error: "Entfernen fehlgeschlagen — bitte erneut versuchen",
      my_dictionary_nav: "Mein Wörterbuch",
      my_dictionary_header: "Mein Wörterbuch",
      my_dictionary_loading: "Wörterbuch wird geladen...",
      my_dictionary_error:
        "Wörterbuch konnte nicht geladen werden — bitte erneut versuchen",
      my_dictionary_empty:
        "Noch keine gespeicherten Wörter. Tippe beim Lesen auf ein Wort und speichere es in deinem Wörterbuch.",
      my_dictionary_meaning_pending: "Übersetzung folgt...",
      my_dictionary_examples_heading: "Beispiele",
      my_dictionary_prev_page: "Zurück",
      my_dictionary_next_page: "Weiter",
      my_dictionary_page_label: "Seite",
      my_dictionary_delete: "Löschen",
      my_dictionary_delete_confirm: "Löschen?",
      my_dictionary_delete_cancel: "Abbrechen",
      my_dictionary_deleting: "Wird gelöscht...",
      my_dictionary_delete_error: "Löschen fehlgeschlagen — bitte erneut versuchen",
      my_dictionary_login_prompt:
        "Anmelden, um deine gespeicherten Wörter zu sehen",
      settings_title: "Einstellungen",
      close_button_caption: "Schließen",
      cancel_button: "Abbrechen",
      generate_overlay_message: "Deine Geschichte wird gestaltet",
      generate_overlay_headline: "Deine {level}-Geschichte ist unterwegs",
      scan_overlay_message: "Deine Seite wird gelesen",
      upload_overlay_message: "Dein Text wird aufbereitet",
      my_stories_header: "Meine Geschichten",
      scan_no_target_text_error:
        "Im Bild wurde kein Text in deiner Lernsprache gefunden",
      scan_error_disallowed:
        "Der Text in diesem Bild ist nicht als Lernmaterial zugelassen. Bitte versuche es mit einer anderen Seite.",
      scan_error: "Bild konnte nicht verarbeitet werden — bitte erneut versuchen",
      upload_title_pre: "Eigenen",
      upload_title_post: "Text hochladen.",
      upload_textarea_heading: "TEXT EINFÜGEN",
      upload_textarea_placeholder:
        "Füge einen Text in deiner Lernsprache ein — einen Brief, einen Artikel, ein paar Buchseiten...",
      upload_submit: "Hochladen",
      upload_in_progress: "Wird verarbeitet...",
      upload_login_prompt: "Anmelden, um eigenen Text hochzuladen",
      upload_too_long: "Text ist zu lang",
      upload_error_disallowed:
        "Dieser Text ist nicht als Lernmaterial zugelassen. Bitte versuche es mit einem anderen Auszug.",
      upload_error_no_target_text:
        "In diesem Text wurde keine Lernsprache gefunden",
      upload_error_generic:
        "Text konnte nicht verarbeitet werden — bitte erneut versuchen",
      reader_menu_label: "Leseoptionen",
      reader_menu_words_section: "Wörter",
      translation_menu_title: "Übersetzung",
      translation_unavailable:
        "Für diese Geschichte ist keine Übersetzung verfügbar.",
      translation_mode_hidden: "Ausgeblendet",
      translation_mode_by_paragraph: "Nach Absätzen",
      translation_mode_by_sentence: "Nach Sätzen",
      color_noun_genders_checkbox: "Substantive nach Geschlecht einfärben",
      color_noun_genders_masculine: "maskulin",
      color_noun_genders_feminine: "feminin",
      color_noun_genders_neuter: "neutrum",
      login_button: "Anmelden",
      signup_button: "Registrieren",
      logout_button: "Abmelden",
      settings_theme: "Design",
      settings_theme_dark: "Dunkel",
      settings_theme_light: "Hell",
      settings_theme_system: "System",
      generate_title_pre: "Neue",
      generate_title_post: "Geschichte erstellen.",
      generate_level_heading: "DEIN NIVEAU",
      generate_mood_heading: "Stimmung",
      generate_topic_heading: "Thema",
      generate_topic_optional: "Optional",
      generate_instructions_heading: "Eigene Wünsche",
      generate_instructions_placeholder:
        "z. B. Fokus auf das Plusquamperfekt, oder eine Geschichte über einen entlaufenen Hund...",
      generate_instructions_help:
        "Gib der Geschichte eine Richtung: eine Grammatikstruktur zum Üben, bestimmten Wortschatz oder eine Handlungsidee.",
      generate_instructions_too_long: "Die Anweisungen sind zu lang",
      generate_login_prompt: "Anmelden, um eine Geschichte zu generieren",
      generate_button: "Generieren!",
      generate_level_required: "Niveau wählen",
      generate_error: "Fehler — erneut versuchen",
      generate_error_disallowed:
        "Diese Wünsche sind für die Generierung nicht zugelassen. Bitte formuliere sie um.",
      generate_error_off_topic:
        "Dieses Feld formt nur deine Geschichte — versuche eine Grammatikstruktur, Wortschatz oder eine Handlungsidee.",
      create_error_daily_limit_reached:
        "Du hast das Limit für 24 Stunden erreicht — versuche es später wieder",
      create_error_request_in_progress:
        "Eine andere Geschichte wird gerade erstellt — warte, bis sie fertig ist",
      create_error_server_busy:
        "Gerade ist viel los — versuche es in einer Minute erneut",
      create_error_daily_limit_reached_unverified:
        "Du hast das Limit für 24 Stunden erreicht — bestätige deine E-Mail-Adresse, um es zu erhöhen, oder versuche es später wieder",
      email_verification_notice:
        "Bestätige deine E-Mail-Adresse {email}, um deine Tageslimits zu erhöhen.",
      email_verification_send: "Bestätigungs-E-Mail senden",
      email_verification_check: "Ich habe sie bestätigt",
      email_verification_sent:
        "Gesendet — schau in dein Postfach und in den Spam-Ordner",
      email_verification_still_unverified:
        "Noch nicht bestätigt — öffne zuerst den Link in der E-Mail",
      email_verification_error:
        "Etwas ist schiefgelaufen — bitte versuche es erneut",
      login_verification_sent_title: "Schau in dein Postfach",
      login_verification_sent_message:
        "Wir haben einen Link an {email} geschickt. Öffne ihn, um deine E-Mail-Adresse zu bestätigen und deine Tageslimits zu erhöhen — loslegen kannst du sofort.",
      login_verification_sent_continue: "Weiter",
      generate_in_progress: "Wird generiert...",
      delete_story_confirm_title: "Diese Geschichte löschen?",
      delete_story_confirm_message:
        "Die Geschichte und alle zugehörigen Daten werden dauerhaft entfernt.",
      delete_story_confirm_button: "Löschen",
      delete_story_button_label: "Geschichte löschen",
      delete_story_deleting: "Wird gelöscht...",
      delete_story_error:
        "Geschichte konnte nicht gelöscht werden — bitte erneut versuchen",
      favorite_story_button_label: "Zu Favoriten hinzufügen",
      unfavorite_story_button_label: "Aus Favoriten entfernen",
      favorite_story_error:
        "Favoriten konnten nicht aktualisiert werden — bitte erneut versuchen",
      mark_story_read_button_label: "Als gelesen markieren",
      mark_story_unread_button_label: "Als ungelesen markieren",
      read_story_error:
        "Gelesen-Markierung konnte nicht aktualisiert werden — bitte erneut versuchen",
      practice_nav: "Üben",
      practice_header: "Üben",
      practice_all_words_link: "Alle meine Wörter",
      practice_autoplay: "Audio automatisch abspielen",
      practice_answer_error: "Einige Antworten konnten nicht gespeichert werden. Prüfe deine Verbindung.",
      practice_loading: "Wird geladen…",
      practice_error: "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
      practice_check_again: "Erneut prüfen",
      practice_keyboard_help: "Tasten: Leertaste zeigt die Antwort, H gibt einen Hinweis, 1–4 bewerten",
      practice_new_word: "Neues Wort",
      practice_tricky_word: "Kniffliges Wort",
      practice_prompt_recognize_word: "Was bedeutet das?",
      practice_prompt_recognize_sentence: "Was bedeutet das markierte Wort?",
      practice_prompt_produce_word: "Wie sagt man das?",
      practice_prompt_produce_sentence: "Fülle die Lücke",
      practice_type_placeholder: "Antwort eintippen (optional)",
      practice_hint: "Hinweis",
      practice_reveal: "Antwort zeigen",
      practice_hint_grade_note: "Du hast einen Hinweis genutzt, daher zählt das höchstens als schwer.",
      practice_grade_forgot: "Vergessen",
      practice_grade_hard: "Schwer",
      practice_grade_medium: "Mittel",
      practice_grade_easy: "Leicht",
      practice_typed_correct: "Richtig!",
      practice_typed_wrong: "Du hast geschrieben: {typed}",
      practice_status_due: "{count} zu wiederholen",
      practice_status_new: "{done}/{goal} neu heute",
      practice_status_level: "Niveau {level}",
      practice_next_due_minutes: "Nächste Wiederholung in {count} Min.",
      practice_next_due_hours: "Nächste Wiederholung in {count} Std.",
      practice_next_due_days: "Nächste Wiederholung in {count} Tagen",
      practice_done_caught_up: "Alles erledigt!",
      practice_done_goal_title: "Tagesziel erreicht!",
      practice_done_goal_text: "Du hast heute {count} neue Wörter gelernt.",
      practice_done_cap_text: "Du hast heute {count} neue Wörter gelernt. Das reicht für einen Tag: Morgen geht es mit neuen Wörtern weiter.",
      practice_done_struggling_text: "Die neuen Wörter von heute brauchen etwas Zeit. Mach eine Pause und komm später wieder.",
      practice_done_consolidating_text: "Deine neuesten Wörter setzen sich noch. In ein paar Minuten geht es weiter.",
      practice_learn_more: "{count} weitere lernen",
      practice_home_due: "{count} Wörter zu wiederholen",
      practice_home_start: "Wörter üben",
      placement_title: "Finde dein Niveau",
      placement_text: "Ein Test von einer Minute: Tippe an, ob du jedes Wort kennst. Manche Wörter sind erfunden, also sei ehrlich! Danach passen deine neuen Wörter zu deinem Niveau.",
      placement_start: "Los geht's",
      placement_skip: "Überspringen",
      placement_loading: "Wörter werden vorbereitet…",
      placement_question: "Kennst du dieses Wort?",
      placement_known: "Kenne ich",
      placement_unknown: "Kenne ich nicht",
      placement_keyboard_help: "Tasten: → kenne ich, ← kenne ich nicht",
      placement_done_title: "Fertig!",
      placement_done_text: "Deine neuen Wörter kommen vom Niveau {level}. Es passt sich beim Üben weiter an.",
      placement_continue: "Weiter",
      gender_round_title: "Genus-Runde",
      gender_round_result: "{correct} von {total} richtig",
      strength_recognize: "Erkennen",
      strength_produce: "Abrufen",
      strength_unpracticed: "noch nicht geübt",
      strength_weak: "schwach",
      strength_learning: "wird besser",
      strength_strong: "sicher",
      my_dictionary_filter_saved: "Gespeichert",
      my_dictionary_filter_all: "Alle Wörter",
      my_dictionary_sort_recent: "Zuletzt hinzugefügt",
      my_dictionary_sort_weakest: "Schwächste zuerst",
      my_dictionary_sort_strongest: "Stärkste zuerst",
      my_dictionary_tricky: "Knifflig",
      my_dictionary_all_empty: "Noch keine Wörter. Hier erscheinen Wörter, die du in Geschichten nachschlägst und übst.",
      account_menu_label: "Kontomenü",
      login_title_signin: "Willkommen zurück",
      login_title_signup: "Konto erstellen",
      login_subtitle_signin: "Melde dich an, um weiterzumachen",
      login_subtitle_signup: "Registriere dich und leg los",
      login_email_label: "E-Mail",
      login_password_label: "Passwort",
      login_password_hint_signup: "Mindestens 6 Zeichen",
      login_submit_signin: "Anmelden",
      login_submit_signup: "Registrieren",
      login_submit_signin_pending: "Wird angemeldet...",
      login_submit_signup_pending: "Wird registriert...",
      login_or: "ODER",
      login_google_button: "Mit Google fortfahren",
      login_toggle_to_signup_question: "Noch kein Konto? ",
      login_toggle_to_signin_question: "Schon ein Konto? ",
      login_toggle_to_signup: "Registrieren",
      login_toggle_to_signin: "Anmelden",
      login_error_invalid_credentials: "Falsche E-Mail oder falsches Passwort",
      login_error_email_in_use:
        "Mit dieser E-Mail existiert bereits ein Konto",
      login_error_weak_password:
        "Passwort ist zu schwach — mindestens 6 Zeichen verwenden",
      login_error_invalid_email: "Diese E-Mail-Adresse sieht nicht richtig aus",
      login_error_too_many_requests:
        "Zu viele Versuche — bitte kurz warten und erneut versuchen",
      login_error_generic: "Anmeldung fehlgeschlagen — bitte erneut versuchen",
      home_hero_title_pre: "Lerne eine Sprache durch",
      home_hero_title_highlight: "Geschichten.",
      home_hero_subtitle:
        "Kurze parallele Geschichten auf deinem Niveau, mit Übersetzung und sofortigen Worterklärungen. Leg gleich los — ganz ohne Konto.",
      home_how_read_title: "Lies auf deinem Niveau",
      home_how_read_description:
        "Jede Geschichte hat ein GER-Niveau, damit du eine passende findest.",
      home_how_tap_title: "Tippe auf ein Wort",
      home_how_tap_description:
        "Erhalte sofort eine Erklärung — direkt im Kontext.",
      home_how_save_title: "Bau dein Wörterbuch auf",
      home_how_save_description:
        "Speichere Wörter, die du dir merken willst, und wiederhole sie jederzeit.",
      home_create_heading: "Mach es persönlich",
      home_create_subtitle:
        "Mit einem kostenlosen Konto machst du aus allem eine Geschichte:",
      home_create_generate_title: "Geschichte generieren",
      home_create_generate_description:
        "Wähle Niveau, Stimmung und Thema — und erhalte eine ganz neue Geschichte, nur für dich geschrieben.",
      home_create_scan_title: "Buchseite scannen",
      home_create_scan_description:
        "Fotografiere eine Seite und lies sie mit Tipp-Erklärungen.",
      home_create_upload_title: "Eigenen Text hochladen",
      home_create_upload_description:
        "Füge einen Brief, Artikel oder Buchauszug ein und mach daraus eine parallele Lektüre.",
      home_cta_title: "Bereit loszulegen?",
      home_cta_subtitle:
        "Erstelle ein kostenloses Konto, um Geschichten zu generieren, Seiten zu scannen und Wörter zu speichern.",
      home_cta_button: "Kostenlos registrieren",
      nav_stories: "Geschichten",
      nav_words: "Wörter",
      reader_back: "Zurück",
      text_size_title: "Textgröße",
      text_size_small: "Klein",
      text_size_medium: "Mittel",
      text_size_large: "Groß",
      read_along_listen: "Geschichte anhören",
      read_along_pause: "Pause",
      read_along_resume: "Weiter anhören",
      read_along_speed: "Vorlesetempo",
      generate_page_title: "Neue Geschichte",
      upload_page_title: "Eigener Text",
      language_i_speak: "Ich spreche",
      language_i_learn: "Ich lerne",
      settings_languages: "Sprachen",
      settings_appearance: "Darstellung",
      greeting_morning: "Guten Morgen",
      greeting_afternoon: "Guten Tag",
      greeting_evening: "Guten Abend",
      greeting_night: "Hallo, Nachteule",
      home_subtitle: "Was liest du heute?",
      continue_reading: "Weiterlesen",
      percent_read: "{percent} % gelesen",
      story_of_the_day: "Geschichte des Tages",
      featured_story_read: "Jetzt lesen",
      featured_story_done: "Gelesen! Morgen gibt es eine neue",
      practice_card_placement: "Finde dein Niveau in einer Minute",
      practice_card_new: "Neue Wörter warten: {count}",
      practice_card_done: "Fürs Erste geschafft",
      create_heading: "Selbst erstellen",
      create_new_story: "Neue Geschichte",
      create_scan: "Seite scannen",
      create_paste: "Text einfügen",
      library_header: "Bibliothek",
      library_subtitle: "Ausgewählte Geschichten zum Lesen und Entdecken",
      library_surprise: "Überrasch mich",
      library_search_label: "Geschichten durchsuchen",
      library_search_placeholder: "Nach Titel suchen",
      library_search_clear: "Suche löschen",
      library_all_levels: "Alle Niveaus",
      library_no_results: "Keine Geschichte passt zu deiner Suche.",
      library_show_all: "Alle {count} Geschichten zeigen",
      home_start_reading: "Jetzt lesen",
      home_browse_library: "Bibliothek ansehen",
      home_preview_label: "Wort antippen, Erklärung bekommen",
      story_minutes: "{count} Min. Lesezeit",
      coach_tap_word: "Tippe auf ein Wort, um zu sehen, was es bedeutet",
      coach_got_it: "Verstanden",
      resume_toast: "Weiter, wo du aufgehört hast",
      resume_start_over: "Von vorn",
      signup_to_save: "Registrieren, um Wörter zu speichern",
      story_end_title: "Ende",
      story_end_congrats: "Du hast die ganze Geschichte gelesen — super!",
      story_end_read_done: "Als gelesen markiert",
      story_end_signup_text: "Mit einem kostenlosen Konto speicherst du Wörter, übst sie und behältst deine Geschichten im Blick.",
      story_end_up_next: "Als Nächstes",
      story_rating_question: "Wie hat dir die Geschichte gefallen?",
      story_rating_star_label: "{rating} von {max} Sternen",
      story_rating_thanks: "Danke für deine Bewertung!",
      story_rating_error:
        "Bewertung konnte nicht gespeichert werden — bitte erneut versuchen",
      story_end_practice: "Deine Wörter üben",
      story_end_practice_story: "Wörter aus dieser Geschichte üben ({count})",
      practice_story_header: "Wörter aus der Geschichte",
      practice_story_done_title: "Wörter der Geschichte geübt!",
      practice_story_done_text: "Aus dieser Geschichte gibt es gerade nichts mehr zu üben. Ihre Wörter kommen beim normalen Üben wieder.",
      practice_story_back: "Zurück zur Geschichte",
      practice_story_continue: "Normal weiterüben",
      practice_done_reviews: "Heute wiederholt: {count}",
      practice_done_new_words: "Neue Wörter heute: {count}",
      practice_read_story: "Eine Geschichte lesen",
      my_dictionary_empty_cta: "Geschichte finden",
      generate_subtitle: "Wähle ein Niveau — und wenn du magst, eine Stimmung und ein Thema. Wir schreiben eine Geschichte nur für dich.",
      levels: {
        A1: "Anfänger",
        B1: "Mittelstufe",
        C1: "Fortgeschritten",
      },
      moods: {
        romantic: "Romantisch",
        dark: "Düster",
        funny: "Lustig",
        silly: "Albern",
        scary: "Gruselig",
        hopeful: "Hoffnungsvoll",
        mysterious: "Geheimnisvoll",
        exciting: "Aufregend",
        charming: "Bezaubernd",
        thoughtful: "Nachdenklich",
        inspiring: "Inspirierend",
        witty: "Witzig",
      },
      topics: {
        office: "Büro",
        family: "Familie",
        travel: "Reisen",
        sports: "Sport",
        technology: "Technologie",
        cooking: "Kochen",
        fashion: "Mode",
        music: "Musik",
        science: "Wissenschaft",
        history: "Geschichte",
        nature: "Natur",
        movies: "Filme",
      },
    },
  ],
  [
    "ru",
    {
      loading_story_list_error: "Ошибка загрузки списка историй",
      loading_generated_story_list_error:
        "Ошибка загрузки списка сгенерированных историй",
      loading_story: "Загрузка истории...",
      loading_story_error: "Ошибка загрузки истории",
      story_not_found_error: "История не найдена :(",
      story_alignment_error:
        "Эту часть истории не удаётся показать: перевод не совпадает с оригиналом.",
      story_back_to_library: "Назад в библиотеку",
      story_login_required: "Войдите, чтобы прочитать эту историю.",
      story_load_retry: "Попробовать снова",
      loading_explain: "Загрузка объяснения...",
      loading_explain_error: "Ошибка загрузки объяснения",
      save_word_preparing: "Подготовка...",
      listen_button: "Слушать",
      listen_stop: "Стоп",
      listen_loading: "Загрузка...",
      listen_error: "Не удалось воспроизвести аудио — попробуйте ещё раз",
      save_word_button: "Сохранить слово",
      explanation_phrase_label: "Часть выражения",
      saving_word: "Сохранение...",
      word_saved: "Сохранено",
      save_word_error: "Не удалось сохранить — попробуйте ещё раз",
      save_word_limit_error:
        "Словарь заполнен (1000 слов) — удалите часть, чтобы добавить ещё",
      remove_word_button: "Удалить из словаря",
      remove_word_error: "Не удалось удалить — попробуйте ещё раз",
      my_dictionary_nav: "Мой словарь",
      my_dictionary_header: "Мой словарь",
      my_dictionary_loading: "Загрузка словаря...",
      my_dictionary_error: "Не удалось загрузить словарь — попробуйте ещё раз",
      my_dictionary_empty:
        "Пока нет сохранённых слов. Нажмите на слово во время чтения и сохраните его в словарь.",
      my_dictionary_meaning_pending: "Перевод готовится...",
      my_dictionary_examples_heading: "Примеры",
      my_dictionary_prev_page: "Назад",
      my_dictionary_next_page: "Вперёд",
      my_dictionary_page_label: "Страница",
      my_dictionary_delete: "Удалить",
      my_dictionary_delete_confirm: "Удалить?",
      my_dictionary_delete_cancel: "Отмена",
      my_dictionary_deleting: "Удаление...",
      my_dictionary_delete_error: "Не удалось удалить — попробуйте ещё раз",
      my_dictionary_login_prompt: "Войдите, чтобы увидеть сохранённые слова",
      settings_title: "Настройки",
      close_button_caption: "Закрыть",
      cancel_button: "Отмена",
      generate_overlay_message: "Создаём вашу историю",
      generate_overlay_headline: "Ваша история уровня {level} уже в пути",
      scan_overlay_message: "Читаем вашу страницу",
      upload_overlay_message: "Обрабатываем ваш текст",
      my_stories_header: "Мои истории",
      scan_no_target_text_error:
        "На изображении не найден текст на изучаемом языке",
      scan_error_disallowed:
        "Текст на этом изображении нельзя использовать как учебный материал. Попробуйте другую страницу.",
      scan_error: "Не удалось обработать изображение — попробуйте ещё раз",
      upload_title_pre: "Загрузите свой",
      upload_title_post: "текст.",
      upload_textarea_heading: "ВСТАВЬТЕ ОТРЫВОК",
      upload_textarea_placeholder:
        "Вставьте текст на изучаемом языке — письмо, статью, несколько страниц книги...",
      upload_submit: "Загрузить",
      upload_in_progress: "Обработка...",
      upload_login_prompt: "Войдите, чтобы загрузить свой текст",
      upload_too_long: "Текст слишком длинный",
      upload_error_disallowed:
        "Этот текст нельзя использовать как учебный материал. Попробуйте другой отрывок.",
      upload_error_no_target_text:
        "В тексте не найден фрагмент на изучаемом языке",
      upload_error_generic: "Не удалось обработать текст — попробуйте ещё раз",
      reader_menu_label: "Настройки чтения",
      reader_menu_words_section: "Слова",
      translation_menu_title: "Перевод",
      translation_unavailable: "Для этой истории нет перевода.",
      translation_mode_hidden: "Скрыт",
      translation_mode_by_paragraph: "По абзацам",
      translation_mode_by_sentence: "По предложениям",
      color_noun_genders_checkbox: "Окрашивать существительные по роду",
      color_noun_genders_masculine: "мужской",
      color_noun_genders_feminine: "женский",
      color_noun_genders_neuter: "средний",
      login_button: "Войти",
      signup_button: "Регистрация",
      logout_button: "Выйти",
      settings_theme: "Тема",
      settings_theme_dark: "Тёмная",
      settings_theme_light: "Светлая",
      settings_theme_system: "Системная",
      generate_title_pre: "Создать новую",
      generate_title_post: "историю.",
      generate_level_heading: "ВАШ УРОВЕНЬ",
      generate_mood_heading: "Настроение",
      generate_topic_heading: "Тема",
      generate_topic_optional: "Необязательно",
      generate_instructions_heading: "Пожелания",
      generate_instructions_placeholder:
        "например, сделать акцент на прошедшем времени или история о сбежавшей собаке...",
      generate_instructions_help:
        "Задайте истории направление: грамматическая конструкция для практики, нужная лексика или идея сюжета.",
      generate_instructions_too_long: "Слишком длинные инструкции",
      generate_login_prompt: "Войдите, чтобы сгенерировать историю",
      generate_button: "Сгенерировать!",
      generate_level_required: "Выберите уровень",
      generate_error: "Ошибка — попробуйте снова",
      generate_error_disallowed:
        "Такие пожелания нельзя использовать для генерации. Пожалуйста, переформулируйте их.",
      generate_error_off_topic:
        "Это поле влияет только на историю — попробуйте указать грамматику, лексику или идею сюжета.",
      create_error_daily_limit_reached:
        "Вы исчерпали лимит на 24 часа — попробуйте позже",
      create_error_request_in_progress:
        "Другая история ещё создаётся — дождитесь, пока она будет готова",
      create_error_server_busy:
        "Сейчас сервер перегружен — попробуйте через минуту",
      create_error_daily_limit_reached_unverified:
        "Вы исчерпали лимит на 24 часа — подтвердите почту, чтобы его увеличить, или попробуйте позже",
      email_verification_notice:
        "Подтвердите адрес {email}, чтобы увеличить дневные лимиты.",
      email_verification_send: "Отправить письмо для подтверждения",
      email_verification_check: "Я подтвердил(а) почту",
      email_verification_sent: "Отправлено — проверьте входящие и папку «Спам»",
      email_verification_still_unverified:
        "Почта ещё не подтверждена — сначала откройте ссылку из письма",
      email_verification_error: "Что-то пошло не так — попробуйте ещё раз",
      login_verification_sent_title: "Проверьте почту",
      login_verification_sent_message:
        "Мы отправили ссылку на {email}. Откройте её, чтобы подтвердить почту и увеличить дневные лимиты, — а начать можно уже сейчас.",
      login_verification_sent_continue: "Продолжить",
      generate_in_progress: "Генерация...",
      delete_story_confirm_title: "Удалить эту историю?",
      delete_story_confirm_message:
        "История и все её данные будут удалены безвозвратно.",
      delete_story_confirm_button: "Удалить",
      delete_story_button_label: "Удалить историю",
      delete_story_deleting: "Удаление...",
      delete_story_error: "Не удалось удалить историю — попробуйте ещё раз",
      favorite_story_button_label: "Добавить в избранное",
      unfavorite_story_button_label: "Убрать из избранного",
      favorite_story_error:
        "Не удалось обновить избранное — попробуйте ещё раз",
      mark_story_read_button_label: "Отметить как прочитанное",
      mark_story_unread_button_label: "Отметить как непрочитанное",
      read_story_error:
        "Не удалось обновить отметку о прочтении — попробуйте ещё раз",
      practice_nav: "Тренировка",
      practice_header: "Тренировка",
      practice_all_words_link: "Все мои слова",
      practice_autoplay: "Автоматически воспроизводить звук",
      practice_answer_error: "Не удалось сохранить некоторые ответы. Проверьте подключение.",
      practice_loading: "Загрузка…",
      practice_error: "Что-то пошло не так. Попробуйте ещё раз.",
      practice_check_again: "Проверить снова",
      practice_keyboard_help: "Клавиши: пробел — показать ответ, H — подсказка, 1–4 — оценка",
      practice_new_word: "Новое слово",
      practice_tricky_word: "Трудное слово",
      practice_prompt_recognize_word: "Что это значит?",
      practice_prompt_recognize_sentence: "Что значит выделенное слово?",
      practice_prompt_produce_word: "Как это сказать?",
      practice_prompt_produce_sentence: "Заполните пропуск",
      practice_type_placeholder: "Введите ответ (необязательно)",
      practice_hint: "Подсказка",
      practice_reveal: "Показать ответ",
      practice_hint_grade_note: "Вы воспользовались подсказкой, поэтому ответ засчитывается не выше, чем «трудно».",
      practice_grade_forgot: "Не помню",
      practice_grade_hard: "Трудно",
      practice_grade_medium: "Средне",
      practice_grade_easy: "Легко",
      practice_typed_correct: "Верно!",
      practice_typed_wrong: "Вы написали: {typed}",
      practice_status_due: "к повторению: {count}",
      practice_status_new: "новых сегодня: {done}/{goal}",
      practice_status_level: "уровень {level}",
      practice_next_due_minutes: "Следующее повторение через {count} мин.",
      practice_next_due_hours: "Следующее повторение через {count} ч.",
      practice_next_due_days: "Следующее повторение через {count} дн.",
      practice_done_caught_up: "Всё повторено!",
      practice_done_goal_title: "Дневная цель выполнена!",
      practice_done_goal_text: "Новых слов сегодня: {count}.",
      practice_done_cap_text: "Новых слов сегодня: {count}. Для одного дня достаточно: новые слова продолжатся завтра.",
      practice_done_struggling_text: "Сегодняшним новым словам нужно время, чтобы запомниться. Сделайте перерыв и возвращайтесь позже.",
      practice_done_consolidating_text: "Самые новые слова ещё закрепляются. Продолжим через несколько минут.",
      practice_learn_more: "Выучить ещё {count}",
      practice_home_due: "Слов к повторению: {count}",
      practice_home_start: "Тренировать слова",
      placement_title: "Определите свой уровень",
      placement_text: "Проверка на минуту: отмечайте, знаете ли вы каждое слово. Некоторые слова выдуманы, так что будьте честны! После этого новые слова будут соответствовать вашему уровню.",
      placement_start: "Начать",
      placement_skip: "Пропустить",
      placement_loading: "Готовим слова…",
      placement_question: "Вы знаете это слово?",
      placement_known: "Знаю",
      placement_unknown: "Не знаю",
      placement_keyboard_help: "Клавиши: → знаю, ← не знаю",
      placement_done_title: "Готово!",
      placement_done_text: "Новые слова будут уровня {level}. Уровень продолжит подстраиваться по ходу тренировок.",
      placement_continue: "Продолжить",
      gender_round_title: "Род существительных",
      gender_round_result: "Правильно: {correct} из {total}",
      strength_recognize: "Узнавание",
      strength_produce: "Вспоминание",
      strength_unpracticed: "ещё не тренировалось",
      strength_weak: "слабо",
      strength_learning: "уже лучше",
      strength_strong: "уверенно",
      my_dictionary_filter_saved: "Сохранённые",
      my_dictionary_filter_all: "Все слова",
      my_dictionary_sort_recent: "Недавно добавленные",
      my_dictionary_sort_weakest: "Сначала слабые",
      my_dictionary_sort_strongest: "Сначала сильные",
      my_dictionary_tricky: "Трудное",
      my_dictionary_all_empty: "Слов пока нет. Здесь появятся слова, которые вы смотрите в историях и тренируете.",
      account_menu_label: "Меню аккаунта",
      login_title_signin: "С возвращением",
      login_title_signup: "Создать аккаунт",
      login_subtitle_signin: "Войдите, чтобы продолжить",
      login_subtitle_signup: "Зарегистрируйтесь, чтобы начать",
      login_email_label: "Электронная почта",
      login_password_label: "Пароль",
      login_password_hint_signup: "Не менее 6 символов",
      login_submit_signin: "Войти",
      login_submit_signup: "Зарегистрироваться",
      login_submit_signin_pending: "Вход...",
      login_submit_signup_pending: "Регистрация...",
      login_or: "ИЛИ",
      login_google_button: "Продолжить с Google",
      login_toggle_to_signup_question: "Ещё нет аккаунта? ",
      login_toggle_to_signin_question: "Уже есть аккаунт? ",
      login_toggle_to_signup: "Зарегистрироваться",
      login_toggle_to_signin: "Войти",
      login_error_invalid_credentials: "Неверная почта или пароль",
      login_error_email_in_use: "Аккаунт с этой почтой уже существует",
      login_error_weak_password:
        "Пароль слишком простой — используйте не менее 6 символов",
      login_error_invalid_email: "Похоже, адрес почты указан неверно",
      login_error_too_many_requests:
        "Слишком много попыток — подождите немного и попробуйте снова",
      login_error_generic: "Не удалось войти — попробуйте ещё раз",
      home_hero_title_pre: "Учите язык, читая",
      home_hero_title_highlight: "истории.",
      home_hero_subtitle:
        "Короткие параллельные истории вашего уровня — с переводом и мгновенными объяснениями слов. Начните читать прямо сейчас, без регистрации.",
      home_how_read_title: "Читайте на своём уровне",
      home_how_read_description:
        "У каждой истории указан уровень CEFR — легко выбрать подходящую.",
      home_how_tap_title: "Нажмите на любое слово",
      home_how_tap_description:
        "Мгновенное объяснение слова прямо в контексте.",
      home_how_save_title: "Собирайте свой словарь",
      home_how_save_description:
        "Сохраняйте слова, которые хотите запомнить, и повторяйте их в любой момент.",
      home_create_heading: "Сделайте чтение личным",
      home_create_subtitle:
        "С бесплатным аккаунтом любая тема или текст превращается в историю:",
      home_create_generate_title: "Сгенерируйте историю",
      home_create_generate_description:
        "Выберите уровень, настроение и тему — и получите новую историю, написанную специально для вас.",
      home_create_scan_title: "Сканируйте страницу книги",
      home_create_scan_description:
        "Сфотографируйте страницу и читайте её с объяснениями по нажатию.",
      home_create_upload_title: "Загрузите свой текст",
      home_create_upload_description:
        "Вставьте письмо, статью или отрывок книги и превратите его в параллельное чтение.",
      home_cta_title: "Готовы начать?",
      home_cta_subtitle:
        "Создайте бесплатный аккаунт, чтобы генерировать истории, сканировать страницы и сохранять слова.",
      home_cta_button: "Зарегистрироваться бесплатно",
      nav_stories: "Истории",
      nav_words: "Слова",
      reader_back: "Назад",
      text_size_title: "Размер текста",
      text_size_small: "Мелкий",
      text_size_medium: "Средний",
      text_size_large: "Крупный",
      read_along_listen: "Слушать историю",
      read_along_pause: "Пауза",
      read_along_resume: "Продолжить",
      read_along_speed: "Скорость озвучки",
      generate_page_title: "Новая история",
      upload_page_title: "Свой текст",
      language_i_speak: "Мой язык",
      language_i_learn: "Я изучаю",
      settings_languages: "Языки",
      settings_appearance: "Оформление",
      greeting_morning: "Доброе утро",
      greeting_afternoon: "Добрый день",
      greeting_evening: "Добрый вечер",
      greeting_night: "Доброй ночи",
      home_subtitle: "Что почитаем сегодня?",
      continue_reading: "Продолжить чтение",
      percent_read: "Прочитано {percent}%",
      story_of_the_day: "История дня",
      featured_story_read: "Читать",
      featured_story_done: "Прочитано! Завтра будет новая",
      practice_card_placement: "Определите свой уровень за минуту",
      practice_card_new: "Ждут новые слова: {count}",
      practice_card_done: "На сейчас всё",
      create_heading: "Создать свою",
      create_new_story: "Новая история",
      create_scan: "Скан страницы",
      create_paste: "Вставить текст",
      library_header: "Библиотека",
      library_subtitle: "Подборка историй для чтения",
      library_surprise: "Удивите меня",
      library_search_label: "Поиск историй",
      library_search_placeholder: "Поиск по названию",
      library_search_clear: "Очистить поиск",
      library_all_levels: "Все уровни",
      library_no_results: "По вашему запросу ничего не нашлось.",
      library_show_all: "Показать все истории ({count})",
      home_start_reading: "Начать читать",
      home_browse_library: "Открыть библиотеку",
      home_preview_label: "Нажмите на слово — получите объяснение",
      story_minutes: "{count} мин чтения",
      coach_tap_word: "Нажмите на любое слово, чтобы узнать, что оно значит",
      coach_got_it: "Понятно",
      resume_toast: "Продолжаем с того же места",
      resume_start_over: "С начала",
      signup_to_save: "Зарегистрируйтесь, чтобы сохранять слова",
      story_end_title: "Конец",
      story_end_congrats: "Вы прочитали всю историю — отлично!",
      story_end_read_done: "Отмечено как прочитанное",
      story_end_signup_text: "С бесплатным аккаунтом вы сможете сохранять слова, тренировать их и следить за прочитанным.",
      story_end_up_next: "Что дальше",
      story_rating_question: "Как вам эта история?",
      story_rating_star_label: "{rating} из {max} звёзд",
      story_rating_thanks: "Спасибо за оценку!",
      story_rating_error: "Не удалось сохранить оценку — попробуйте ещё раз",
      story_end_practice: "Повторить слова",
      story_end_practice_story: "Повторить слова из этой истории ({count})",
      practice_story_header: "Слова из истории",
      practice_story_done_title: "Слова из истории повторены!",
      practice_story_done_text: "Из этой истории пока больше нечего повторять. Её слова вернутся в обычной тренировке.",
      practice_story_back: "Вернуться к истории",
      practice_story_continue: "Продолжить обычную тренировку",
      practice_done_reviews: "Повторено сегодня: {count}",
      practice_done_new_words: "Новых слов сегодня: {count}",
      practice_read_story: "Почитать историю",
      my_dictionary_empty_cta: "Найти историю",
      generate_subtitle: "Выберите уровень — и, если хотите, настроение и тему. Мы напишем историю специально для вас.",
      levels: {
        A1: "Начинающий",
        B1: "Средний",
        C1: "Продвинутый",
      },
      moods: {
        romantic: "Романтическое",
        dark: "Мрачное",
        funny: "Смешное",
        silly: "Глупое",
        scary: "Страшное",
        hopeful: "Обнадеживающее",
        mysterious: "Таинственное",
        exciting: "Захватывающее",
        charming: "Очаровательное",
        thoughtful: "Задумчивое",
        inspiring: "Вдохновляющее",
        witty: "Остроумное",
      },
      topics: {
        office: "Офис",
        family: "Семья",
        travel: "Путешествия",
        sports: "Спорт",
        technology: "Технологии",
        cooking: "Кулинария",
        fashion: "Мода",
        music: "Музыка",
        science: "Наука",
        history: "История",
        nature: "Природа",
        movies: "Кино",
      },
    },
  ],
]);

export function lstr(locale: string): LocalizationStrings {
  const s = strings.get(locale);
  if (!s) {
    console.error("Unknown localization locale", locale);
    return strings.get("en")!;
  }
  return s;
}

// fillPlaceholders replaces every {name} in a localized string with
// values[name], or with nothing when values has no such name.
export function fillPlaceholders(
  template: string,
  values: Record<string, string | number>,
) {
  return template.replace(/\{(\w+)\}/g, (_, name) =>
    String(values[name] ?? ""),
  );
}
